// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ChevronsUp } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconChevronsUp(props: any) {
    return <IconBase icon={ChevronsUp} {...props} />
  }

  export default IconChevronsUp
  